import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice"; // Import the user reducer

const store = configureStore({
  reducer: {
    user: userReducer, // Add user reducer to store
  },
});

export default store;
